
import { css } from 'lit';
export default css`
:host{
  display:block;
}

.logo{
  width:128px;
  display:flex;
}

.logo svg{
    width:100%;
  }

.logo--primary{
  width:111px;
}

@media (min-width: 992px){
  .logo--primary{
    width:128px;
  }
}

@media (min-width: 1280px){
  .logo{
    width:162px;
  }

  .logo--primary{
    width:191px;
  }
}

.logo--dark{
  color:var(--primary-eggplant);
  fill:var(--primary-eggplant);
}

.logo--light{
  color:var(--primary-white);
  fill:var(--primary-white);
}
`;